import { render, staticRenderFns } from "./pg_company.vue?vue&type=template&id=32b67769"
import script from "./pg_company.vue?vue&type=script&lang=js"
export * from "./pg_company.vue?vue&type=script&lang=js"
import style0 from "./pg_company.vue?vue&type=style&index=0&id=32b67769&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports